import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { CockpitCustomerContext } from 'context/CockpitCustomerContext';
import { useContext, useState } from 'react';
import '../quickCashflow.scss';
import FprInputs from './FprInputs';
import FprResults from './FprResults';
import { DEFAULT_FPR_INPUTS, runFprSolver } from './calc/fprSolver';

function createDefaultInputs() {
  return {
    ...DEFAULT_FPR_INPUTS,
    anchors: DEFAULT_FPR_INPUTS.anchors.map((anchor) => ({ ...anchor })),
  };
}

function FprSimulator() {
  const { customer } = useContext(CockpitCustomerContext);
  const [inputs, setInputs] = useState(createDefaultInputs);
  const [result, setResult] = useState(null);

  const onGo = () => {
    setResult(runFprSolver(inputs));
  };

  return (
    <Box className="quick-cashflow-page" px={8} py={5} maxW="1400px" mx="auto">
      <Box mb={6}>
        <Text fontSize="xs" textTransform="uppercase" color="gray.400">
          First Underwriting
        </Text>
        <Flex justify="space-between" align="flex-start" gap={4} wrap="wrap">
          <Text fontSize="2xl" fontWeight="bold" className="brand">
            {customer?.companyName || 'Customer'} — FPR
          </Text>
          <Button colorScheme="purple" size="sm" onClick={onGo}>
            Go
          </Button>
        </Flex>
      </Box>

      <FprInputs value={inputs} onChange={setInputs} />

      <Flex justify="flex-end" mt={6}>
        <Button colorScheme="purple" onClick={onGo}>
          Go
        </Button>
      </Flex>

      <FprResults result={result} />
    </Box>
  );
}

export default FprSimulator;
